// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"56829076","496":"dc9b54a4","608":"b7454008"}[chunkId] + ".chunk.js";
};